import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPMaltaAdmissionDEData } from "@/src/types/admissionOffice";
import type { DoubleLangCountry, SecondLangCode } from "./admissionLetterDoubleLangRegistry";

const emptyState = (): AOPMaltaAdmissionDEData => ({
  currentDate: "",
  fullName: "",
  dateOfBirth: "",
  nationality: "",
  course: "",
  userOffice: "01",
  whose_doc: "",
  title: "",
  duration: "",
  mediumOfInstruction: "",
  coursePrefix: "",
  invoiceBody: [],
  body: [],
  bodySecondLanguage: [],
  invoiceBodySecondLanguage: [],
  nationalitySecondLanguage: "",
  courseSecondLanguage: "",
  mediumOfInstructionSecondLanguage: "",
  durationSecondLanguage: "",
});

export interface AOPAdmissionLetterDoubleLangLayoutProps {
  country: DoubleLangCountry;
  secondLang: SecondLangCode;
}

const AOPAdmissionLetterDoubleLangLayout = ({ country, secondLang }: AOPAdmissionLetterDoubleLangLayoutProps) => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPMaltaAdmissionDEData>(emptyState);
  const [bodyForPrev, setBodyForPrev] = useState<AOPMaltaAdmissionDEData>(emptyState);
  const [showInvoiceInPreview, setShowInvoiceInPreview] = useState(false);

  return (
    <div className="container admission-office-page">
      <AOPConfig
        country={country}
        secondLang={secondLang}
        dataForGeneration={dataForGeneration}
        setDataForGeneration={setDataForGeneration}
        setBodyForPrev={setBodyForPrev}
        setShowInvoiceInPreview={setShowInvoiceInPreview}
      />
      <AOPPrev country={country} secondLang={secondLang} bodyForPrev={bodyForPrev} showInvoiceInPreview={showInvoiceInPreview} />
    </div>
  );
};

export default AOPAdmissionLetterDoubleLangLayout;
